import React from 'react';
import PropTypes from 'prop-types';

const NoOccasionalGuests = ({ color = '#224251', background = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 20.2v-2.7m0 0H10.2m10.8 0v-1.8a2.7 2.7 0 0 0-2.7-2.7h-8.1v4.5m-7.2 0h7.2M3 12.1v8.1M4.8 13a1.8 1.8 0 1 0 3.6 0 1.8 1.8 0 0 0-3.6 0Z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M11.1 6.7h.9l-.9.9h.9m.45-2.7h1.2l-1.2 1.2h1.2"
    />
    <path
      stroke={color}
      strokeLinejoin="round"
      strokeWidth={0.7}
      d="M9.792 5.8a2.384 2.384 0 0 0-.111.72c0 1.296 1.032 2.346 2.305 2.346.314 0 .625-.064.914-.191a2.31 2.31 0 0 1-2.195 1.625C9.432 10.3 8.4 9.25 8.4 7.954c0-.965.573-1.794 1.392-2.154Z"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.373}
      fill={color}
      stroke={background}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.373)"
    />
  </svg>
);

NoOccasionalGuests.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string
};

export default NoOccasionalGuests;
